// Static wedding data — names, date, venues, images
export const WEDDING = {
  brideFirst: "Carmen Caroliina",
  groomFirst: "Kerbert",
  brideLast: "Osula",
  groomLast: "Viimsalu",
  // 10.10.2026 — ceremony at 14:00 local Estonia time (UTC+3 in October — actually UTC+3 in summer, EET = UTC+2 in October)
  date: "2026-10-10T15:00:00+03:00",
  hashtag: "#CarmenJaKerbert",
  city: { en: "Tallinn · Estonia", et: "Tallinn · Eesti" },
  venue: {
    ceremony: {
      name: { en: "Mustamäe Maarja Magdaleena Church", et: "Mustamäe Maarja Magdaleena kirik" },
      time: "15:00",
      address: { en: "Mustamäe, Tallinn, Estonia", et: "Mustamäe, Tallinn, Eesti" },
    },
    reception: {
      name: { en: "Old City Harbour Cruise Terminal", et: "Vanasadama Kruiisiterminal" },
      time: "17:00",
      address: { en: "Logi 4/1, Tallinn, Estonia", et: "Logi 4/1, Tallinn, Eesti" },
    },
  },
};

export const GALLERY_IMAGES = [
  // New photos (uploaded 2026-08-01)
  {
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/2s7il5i0_pilt%201.jpg",
    span: "md:col-span-7 aspect-[4/5]",
    alt: "A dance under fairy lights",
    whiteBg: true,
  },
  {
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/5v7akurz_pilt%202.jpg",
    span: "md:col-span-5 aspect-[4/5]",
    alt: "A quiet kiss",
    whiteBg: true,
  },
  // Restored older frame — lift under lights
  {
    url: "https://customer-assets.emergentagent.com/job_bride-groom-hub-75/artifacts/340tbirr_CLP08533.webp",
    span: "md:col-span-12 aspect-[16/10]",
    alt: "The lift under the lights",
  },
  // Studio duo
  {
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/arpcrdq5_CLP08740.webp",
    span: "md:col-span-6 aspect-[4/5]",
    alt: "Studio — sitting side by side",
  },
  {
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/p07wpdwb_CLP08755.webp",
    span: "md:col-span-6 aspect-[4/5]",
    alt: "Studio — a laugh together",
  },
  // New studio pair (uploaded 2026-08-01)
  {
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/6badz2ud_WhatsApp%20Image%202026-08-01%20at%2012.40.47.webp",
    span: "md:col-span-6 aspect-[4/5]",
    alt: "Studio — a warm embrace",
    whiteBg: true,
  },
  {
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/ia3jter7_WhatsApp%20Image%202026-08-01%20at%2012.40.48.webp",
    span: "md:col-span-6 aspect-[4/5]",
    alt: "Studio — the dip",
    whiteBg: true,
  },
  // Ring — panoramic
  {
    url: "https://customer-assets.emergentagent.com/job_bride-groom-hub-75/artifacts/qt2sf1cv_CLP08327.webp",
    span: "md:col-span-12 aspect-[16/9]",
    alt: "The ring",
  },
];
